import angular from 'angular';
import headerMainComponent from './headerMain.component';

const headerMainModule = angular.module('headerMain', ['constants'])

.component('headerMain', headerMainComponent);

export default headerMainModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/headerMain/headerMain.js
 **/